import { render } from "./SnailSurvey.vue?vue&type=template&id=2c20285d&scoped=true"
import script from "./SnailSurvey.vue?vue&type=script&lang=js"
export * from "./SnailSurvey.vue?vue&type=script&lang=js"

import "./SnailSurvey.vue?vue&type=style&index=0&id=2c20285d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c20285d"]])

export default __exports__